import { connect } from 'react-redux';
import { actions } from 'app-webtech-core';
import { EmbedNotificationComponent } from '../components/EmbedNotification';

const mapStateToProps = (state) => {
  return {
    isEmbed: state.embed.enabled || state.embed.corpEmbed,
  };
};

const mapDispatchToProps = dispatch => ({
  linkClickBeacon: () => dispatch(actions.application.linkClick()),
});

export const EmbedNotification = connect(
  mapStateToProps,
  mapDispatchToProps,
)(EmbedNotificationComponent);
